// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ErrorAccountCreation_errorAccountCreationContainer__gdMGE {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 450px;
  background-color: #f7e8e8;
}

.ErrorAccountCreation_errorAccountCreationImage__jTDhm {
  height: 220px;
}

.ErrorAccountCreation_errorAccountCreationTextContainer__zeveU {
  max-width: 370px;
}

.ErrorAccountCreation_errorAccountCreationTitle__nbPOl {
  font-size: 22px !important;
  font-weight: bold;
  margin-bottom: 30px !important;
}

.ErrorAccountCreation_errorAccountCreationSubtitle__XIi83 {
  font-size: 22px !important;
}

.ErrorAccountCreation_errorAccountCreationEmail__-\\+Z-R {
  color: var(--color-font-blue);
}

.ErrorAccountCreation_errorAccountCreationCopy__uUxU3 {
  margin-bottom: 30px !important;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/AccountCreation/components/ErrorAccountCreation/ErrorAccountCreation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB","sourcesContent":[".errorAccountCreationContainer {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  width: 100%;\n  height: 450px;\n  background-color: #f7e8e8;\n}\n\n.errorAccountCreationImage {\n  height: 220px;\n}\n\n.errorAccountCreationTextContainer {\n  max-width: 370px;\n}\n\n.errorAccountCreationTitle {\n  font-size: 22px !important;\n  font-weight: bold;\n  margin-bottom: 30px !important;\n}\n\n.errorAccountCreationSubtitle {\n  font-size: 22px !important;\n}\n\n.errorAccountCreationEmail {\n  color: var(--color-font-blue);\n}\n\n.errorAccountCreationCopy {\n  margin-bottom: 30px !important;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorAccountCreationContainer": `ErrorAccountCreation_errorAccountCreationContainer__gdMGE`,
	"errorAccountCreationImage": `ErrorAccountCreation_errorAccountCreationImage__jTDhm`,
	"errorAccountCreationTextContainer": `ErrorAccountCreation_errorAccountCreationTextContainer__zeveU`,
	"errorAccountCreationTitle": `ErrorAccountCreation_errorAccountCreationTitle__nbPOl`,
	"errorAccountCreationSubtitle": `ErrorAccountCreation_errorAccountCreationSubtitle__XIi83`,
	"errorAccountCreationEmail": `ErrorAccountCreation_errorAccountCreationEmail__-+Z-R`,
	"errorAccountCreationCopy": `ErrorAccountCreation_errorAccountCreationCopy__uUxU3`
};
export default ___CSS_LOADER_EXPORT___;
